//@flow

import React from "react"
import { FormattedMessage } from "react-intl"
import { Cubic, TweenMax } from "gsap"

import SVGLoader from "../../../UI/SVGLoader"
import {
  ContentContainer,
  Titles,
  WalkMonster,
  Background,
  Midground,
  TitleDescription,
  TitleText
} from "./UI"

import walkMonster from "./walkMonster.svg"
import walkBackground from "./walkBackground.svg"
import walkMidGround from "./walkMidGround.svg"

type Props = {}

class WalkView extends React.Component<Props> {
  introText: HTMLElement[]
  monster: ?HTMLElement
  container: ?HTMLElement
  city: ?HTMLElement
  clouds: ?HTMLElement

  constructor(props: Props) {
    super(props)
    this.introText = []
    this.container = null
    this.monster = null
    this.clouds = null
    this.city = null
  }

  componentDidMount() {
    this.showIntroText()
    this.showScene()
  }

  showIntroText = () => {
    const intro = this.introText.filter(el => el !== null)
    TweenMax.set(intro, { y: "40", opacity: 0 })
    TweenMax.staggerTo(
      intro,
      0.5,
      { y: "0", opacity: 1, ease: Cubic.easeOut, delay: 0.5 },
      0.2
    )
  }

  showScene = () => {
    TweenMax.set(this.city, { opacity: 0, x: 200 })
    TweenMax.set(this.monster, { opacity: 0, x: 400 })
    TweenMax.set(this.clouds, { opacity: 0, x: 100 })
    TweenMax.staggerTo(
      [this.monster, this.city, this.clouds],
      1,
      {
        opacity: 1,
        ease: Cubic.easeOut,
        delay: 1
      },
      0.1
    )
    TweenMax.to(this.clouds, 3, { x: 0, ease: Cubic.easeOut, delay: 1 })
    TweenMax.to(this.monster, 3, { x: 0, ease: Cubic.easeOut, delay: 1 })
    TweenMax.to(this.city, 3, { x: 0, ease: Cubic.easeOut, delay: 1 })
  }

  render() {
    return (
      <ContentContainer innerRef={el => (this.container = el)}>
        <Titles>
          <TitleText innerRef={el => this.introText.push(el)}>
            <FormattedMessage id="kiosk.commit.walk.title" />
          </TitleText>
          <TitleDescription innerRef={el => this.introText.push(el)}>
            <FormattedMessage id="kiosk.commit.walk.intro" />
          </TitleDescription>
        </Titles>
        <WalkMonster innerRef={el => (this.monster = el)}>
          <SVGLoader path={walkMonster} height="100%" width="100%" />
        </WalkMonster>
        <Midground innerRef={el => (this.city = el)}>
          <SVGLoader path={walkMidGround} height="100%" width="100%" />
        </Midground>
        <Background innerRef={el => (this.clouds = el)}>
          <SVGLoader path={walkBackground} height="100%" width="100%" />
        </Background>
      </ContentContainer>
    )
  }
}

export default WalkView



// WEBPACK FOOTER //
// ./src/Kiosk/CommitView/Walk/index.js